import httpClient from './api/httpClient';

const END_POINT = 'usuario-interno';
export const getAll = () => httpClient.get(END_POINT + '/all');
export const getUsuarioPorCpf = (cpf) => httpClient.get(END_POINT + '/getUsuarioPorCpf/' + cpf)

export const create = (usrInterno) => {
    let usrInternoForm = {        
        cpf: usrInterno.cpf,
        role: usrInterno.role,
    };
    return httpClient.post(END_POINT, usrInternoForm);
}




